<div class="layout-controls">
  <span class="layout-label">{{ 'translations.collections.layoutView' | transloco }}</span>
  <div class="layout-buttons">
    <button class="layout-btn" [class.active]="currentLayoutView === 'CardView'" title="Grid" (click)="onLayoutViewChange('CardView')">
      <ptl-icon [icon]="LucideLayoutGrid" size="xs"></ptl-icon>
    </button>
    <button class="layout-btn" [class.active]="currentLayoutView === 'ListView'" title="List" (click)="onLayoutViewChange('ListView')">
      <ptl-icon [icon]="LucideTextAlignJustify" size="xs"></ptl-icon>
    </button>
    <button class="layout-btn" [class.active]="currentLayoutView === 'SnakeView'" title="List" (click)="onLayoutViewChange('SnakeView')">
      <ptl-icon [icon]="LucideListEnd" size="xs"></ptl-icon>
    </button>
  </div>
</div>
